import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DialogActions, Typography, useTheme } from "@mui/material";
import { CardQuantityControl } from "../ItemCard/components/CardQuantityControl";
import { ItemChip } from "../ItemCard/components/ItemChip";
import { SymbolFlags } from "../ItemCard/components/SymbolFlags";
import { DetailTabHeading } from "./DetailTabHeading";
/**
 * ItemDetailGeneral - Tab Displayed for Recipes and Products. Shows description of item and additional information depending on context.
 * @param {*} { props: ItemDetailGeneral }
 * @returns {*}
 */
export function ItemDetailGeneral(props) {
    const { itemName, itemDescription, itemChips, cardControlProps, cardControl, symbolFlags, setDialogContentMode } = props;
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [_jsx(DetailTabHeading, { itemName: itemName }), itemDescription && (_jsx(Typography, { variant: "body1", dangerouslySetInnerHTML: { __html: itemDescription } })), _jsx(Box, Object.assign({ style: {
                    marginTop: theme.spacing(2),
                    marginBottom: theme.spacing(2),
                } }, { children: _jsx(SymbolFlags, { symbolFlags: symbolFlags, maxSymbols: 20 }) })), itemChips && itemChips.length > 0 && (_jsx(Box, Object.assign({ style: {
                    marginTop: theme.spacing(2),
                    marginBottom: theme.spacing(2),
                } }, { children: itemChips.map((recipeType) => (_jsx(ItemChip, { label: recipeType }, recipeType))) }))), _jsx(DialogActions, Object.assign({ sx: { position: "relative", justifyContent: "center", alignItems: "center" } }, { children: cardControl ? cardControl : cardControlProps && _jsx(CardQuantityControl, Object.assign({}, cardControlProps)) }))] }));
}
